import React from 'react';
import { inject, observer } from 'mobx-react';
import { AppTemplate } from 'themes/components';

@inject(i => ({ rootStore: i.rootStore }))
@observer
class App extends React.Component {
	constructor(props) {
		super(props);
		this.rootStore = props.rootStore;
	}

	async componentDidMount() {
		await this.rootStore.appStore.initialize();
	}
	render() {
		const { routerStore, routerMaps } = this.rootStore;
		return <AppTemplate routerStore={routerStore} routerMaps={routerMaps} />;
	}
}

export default App;
